module.exports = __webpack_public_path__ + "img/copy-icon-alternative.3cb433f8.svg";